import React from 'react';
import { XIcon } from 'lucide-react';
import { painGroups } from '../data/content';
export function Problem() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-190" data-mp="2pe7eu3w4nl5a">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-191" data-mp="2bfzls727p3ze">
        <h2 className="mx-auto max-w-narrow text-center font-display text-[2rem] font-extrabold leading-[1.1] tracking-tight text-ink md:text-5xl" data-id="element-192" data-mp="2bffzke5j3tfk">
          ¿Reconoces alguno de estos?
        </h2>

        <div className="mx-auto mt-12 grid max-w-4xl gap-6 md:grid-cols-2 md:gap-8" data-id="element-193" data-mp="21ntja3ec345y">
          {painGroups.map(group => <div key={group.audience} className="flex h-full flex-col" data-id="element-194" data-mp="1sp81iagort68">
              <h3 className="font-display text-xl font-extrabold tracking-tight text-ink md:text-2xl" data-id="element-195" data-mp="1sn5598oxx3t2">
                {group.audience}
              </h3>
              <ul className="mt-5 space-y-3" data-id="element-196" data-mp="1iqsfglwina3l">
                {group.points.map(point => <li key={point} className="flex items-start gap-4 rounded-2xl bg-alert-50 px-5 py-4 ring-1 ring-alert-100" data-id="element-197" data-mp="1nqeris0lykat">
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-alert-100 text-alert-600" data-id="element-198" data-mp="obdff2r82q8w">
                      <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-199" data-mp="12a3cwjhyerxs" />
                    </span>
                    <span className="font-medium leading-snug text-ink" data-id="element-200" data-mp="xc1vs44392oy">{point}</span>
                  </li>)}
              </ul>
            </div>)}
        </div>

        <p className="mx-auto mt-12 max-w-2xl text-center font-display text-2xl font-extrabold italic leading-snug tracking-tight text-blue-600 md:text-4xl" data-id="element-201" data-mp="5lnmymaxmgk5">
          No es falta de estudio. Es falta de un sistema visual.
        </p>
      </div>
    </section>;
}